export default "__VITE_ASSET__ebf0a00a__"